<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="collectionData"
            :items-per-page="20"
            :footer-props="{
              'items-per-page-options': [20, 50, 100, 200, -1],
            }"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Shopify Collection</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="saveShopifyCollection()">
                  SALVA
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.willy_family_id="{ isSelected, item }">
              <v-autocomplete
                v-model="item.willy_family_id"
                :items="families"
                item-text="ACL_DESCLA1"
                item-value="ACL_CODCLA1"
                deletable-chips
                small-chips
                solo
                chips
                dense
                label="Famiglie"
                multiple
              ></v-autocomplete>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss"></style>
<script>
import requests from "../../requests";
export default {
  name: "shopofy-collection-list",
  data: () => {
    return {
      headers: [
        { text: "ID Collection", value: "collect_id" },
        { text: "Titolo", value: "collect_title" },
        { text: "Famiglie Willy", value: "willy_family_id" },
      ],
      families: [],
      collectionData: [],
    };
  },
  mounted() {
    console.log("Shopify Collection List Mounted.");

    let def0 = requests.getShopifyCollectionList();
    let def1 = requests.getFamilies();

    Promise.all([def0, def1]).then((res) => {
      this.collectionData = res[0].data;
      this.families = res[1].data;
    });
  },
  methods: {
    getCollection() {
      requests.getShopifyCollectionList().then((res) => {
        this.collectionData = res.data;
      });
    },
    getFamiglie() {
      requests.getFamilies().then((res) => {
        this.families = res.data;
      });
    },
    saveShopifyCollection() {
      requests.saveProductCollection(this.collectionData).then((res) => {

      });
    },
  },
};
</script>